/* Motion toggle — footer control that forces STATIC and persists the pref.
   Cinematic → clicking flips to "static".  Static → clicking clears the pref
   and lets the auto-detector decide (usually returns to cinematic on desktop). */
import { useEffect, useState } from "react";
import { getMotionPref, setMotionPref } from "@/lib/cinematic/motionPref";

export default function MotionToggle() {
  const [pref, setPref] = useState(getMotionPref());

  useEffect(() => {
    const onChange = (e) => setPref(e.detail);
    window.addEventListener("dt6:motion-pref-change", onChange);
    return () => window.removeEventListener("dt6:motion-pref-change", onChange);
  }, []);

  const isStatic = pref === "static";
  const label = isStatic ? "Restore motion" : "Reduce motion";
  const onClick = () => setMotionPref(isStatic ? null : "static");

  return (
    <button
      type="button"
      onClick={onClick}
      className="dt6-motion-toggle font-mono text-[0.65rem] tracking-[0.18em] uppercase"
      data-testid="motion-toggle"
      aria-pressed={isStatic ? "true" : "false"}
      title="Force the site into static (no-motion) mode.  Persists across sessions."
    >
      <span
        aria-hidden="true"
        className="dt6-motion-toggle-dot"
        data-state={isStatic ? "off" : "on"}
      />
      {label}
    </button>
  );
}
